module.exports = __webpack_public_path__ + "static/media/penguin.b988af6a.png";